'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["size", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { memo } from 'react';
import { useFillIds } from "../../hooks/useFillId";
import { TITLE } from "../style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Icon = /*#__PURE__*/memo(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '1em' : _ref$size,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useFillIds = useFillIds(TITLE, 6),
    _useFillIds2 = _slicedToArray(_useFillIds, 6),
    a = _useFillIds2[0],
    b = _useFillIds2[1],
    c = _useFillIds2[2],
    d = _useFillIds2[3],
    e = _useFillIds2[4],
    f = _useFillIds2[5];
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    height: size,
    style: _objectSpread({
      flex: 'none',
      lineHeight: 1
    }, style),
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("title", {
      children: TITLE
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.533 1.829A2.528 2.528 0 0015.11 0h-.737a2.531 2.531 0 00-2.484 2.087l-1.263 6.937.314-1.08a2.528 2.528 0 012.424-1.833h4.284l1.797.706 1.731-.706h-.505a2.528 2.528 0 01-2.423-1.829l-.715-2.453z",
      fill: a.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.726 20.16A2.528 2.528 0 009.152 22h1.566c1.37 0 2.49-1.1 2.525-2.48l.17-6.69-.357 1.228a2.528 2.528 0 01-2.423 1.83h-4.32l-1.54-.842-1.667.843h.497c1.124 0 2.113.75 2.426 1.84l.697 2.432z",
      fill: b.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 0H6.252c-2.5 0-4 3.331-5 6.662-1.184 3.947-2.734 9.225 1.75 9.225H6.78c1.13 0 2.12-.753 2.43-1.847.657-2.317 1.809-6.359 2.713-9.436.46-1.563.842-2.906 1.43-3.742A1.97 1.97 0 0115 0",
      fill: c.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 0H6.252c-2.5 0-4 3.331-5 6.662-1.184 3.947-2.734 9.225 1.75 9.225H6.78c1.13 0 2.12-.753 2.43-1.847.657-2.317 1.809-6.359 2.713-9.436.46-1.563.842-2.906 1.43-3.742A1.97 1.97 0 0115 0",
      fill: d.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 22h8.749c2.5 0 4-3.332 5-6.663 1.184-3.948 2.734-9.227-1.75-9.227H17.22c-1.129 0-2.12.754-2.43 1.848a1149.2 1149.2 0 01-2.713 9.437c-.46 1.564-.842 2.907-1.43 3.743A1.97 1.97 0 019 22",
      fill: e.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 22h8.749c2.5 0 4-3.332 5-6.663 1.184-3.948 2.734-9.227-1.75-9.227H17.22c-1.129 0-2.12.754-2.43 1.848a1149.2 1149.2 0 01-2.713 9.437c-.46 1.564-.842 2.907-1.43 3.743A1.97 1.97 0 019 22",
      fill: f.fill,
      transform: "translate(0 1)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("radialGradient", {
        cx: "85.44%",
        cy: "100.653%",
        fx: "85.44%",
        fy: "100.653%",
        gradientTransform: "scale(-.8553 -1) rotate(50.927 2.041 -1.946)",
        id: a.id,
        r: "105.116%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "9.6%",
          stopColor: "#00AEFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "77.3%",
          stopColor: "#2253CE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#0736C4"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        cx: "18.143%",
        cy: "32.928%",
        fx: "18.143%",
        fy: "32.928%",
        gradientTransform: "scale(.8897 1) rotate(52.069 .193 .352)",
        id: b.id,
        r: "95.612%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#FFB657"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "63.4%",
          stopColor: "#FF5F3D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "92.3%",
          stopColor: "#C02B3C"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        cx: "82.987%",
        cy: "-9.792%",
        fx: "82.987%",
        fy: "-9.792%",
        gradientTransform: "scale(-1 -.9441) rotate(-70.872 .142 1.17)",
        id: e.id,
        r: "140.622%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "6.6%",
          stopColor: "#8C48FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "50%",
          stopColor: "#F2598A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "89.6%",
          stopColor: "#FFB152"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: c.id,
        x1: "39.465%",
        x2: "46.884%",
        y1: "12.117%",
        y2: "103.774%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "15.6%",
          stopColor: "#0D91E1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "48.7%",
          stopColor: "#52B471"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "65.2%",
          stopColor: "#98BD42"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "93.7%",
          stopColor: "#FFC800"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: d.id,
        x1: "45.949%",
        x2: "50%",
        y1: "0%",
        y2: "100%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#3DCBFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "24.7%",
          stopColor: "#0588F7",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: f.id,
        x1: "83.507%",
        x2: "83.453%",
        y1: "-6.106%",
        y2: "21.131%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "5.8%",
          stopColor: "#F8ADFA"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "70.8%",
          stopColor: "#A86EDD",
          stopOpacity: "0"
        })]
      })]
    })]
  }));
});
export default Icon;